/**
 * @description 문자열이 숫자와 영문으로만 이루어져있는지 체크하는 함수
 * @returns boolean, (true: 숫자와 영문만 포함, false: 숫자와 영문 외 다른 글자 포함)
 */

const validateAlphabetNumericOnly = (str: string) => {
  const regex = /^[a-zA-Z\d]*$/;

  return regex.test(str);
};

export default validateAlphabetNumericOnly;
